/** Kebab-case slug a user types after `/`: starts with a letter, at most 64 characters. */
export const SKILL_SLUG_MAX_LENGTH = 64;

export const SKILL_SLUG_PATTERN = "[a-z][a-z0-9]*(?:-[a-z0-9]+)*";

const SKILL_SLUG_RE = new RegExp(`^${SKILL_SLUG_PATTERN}$`);

/** A skill's id: a UUID, any hex case. */
export const SKILL_ID_PATTERN =
  "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}";

const SKILL_ID_RE = new RegExp(`^${SKILL_ID_PATTERN}$`);

/** True when the id can match the Skill table's UUID column. */
export function isSkillId(id: string): boolean {
  return SKILL_ID_RE.test(id);
}

export function isValidSkillSlug(slug: string): boolean {
  return slug.length <= SKILL_SLUG_MAX_LENGTH && SKILL_SLUG_RE.test(slug);
}

/** Derive a valid slug from a display name; prefixes `skill-` when it would not start with a letter. */
export function slugifySkillDisplayName(displayName: string): string {
  const base = displayName
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  if (base.length === 0) {
    return "skill";
  }
  const lettered = /^[a-z]/.test(base) ? base : `skill-${base}`;
  return lettered.slice(0, SKILL_SLUG_MAX_LENGTH).replace(/-+$/, "");
}
